import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
} from "reactstrap"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from '../Utility'

// actions
import { createCompany, companySuccess, companyError, updateCompany } from "../../store/actions";
import { profileSuccess, getProfile } from '../../store/auth/profile/actions';
import { get } from '../../helpers/api_helper';
import Header from '../../components/VerticalLayout/Header';
import Login from '../Authentication/Login';

const Company = props => {
  const { user, company } = props;
  const [data, setData] = useState(null);
  const [endpoint, setEndpoint] = useState("");

  useEffect(() => {
    console.log('props on company view', props);
    if (props.location.pathname.split("/").length > 0) {
      setEndpoint(props.location.pathname.split("/")[props.location.pathname.split("/").length - 1]);
    }
  }, []);

  useEffect(() => {
    if (endpoint)
      getEndpoint();
  }, [endpoint]);

  const getEndpoint = () => {
    get('/company/view?endpoint=' + endpoint)
      .then((json) => {
        console.log('response from get company by endpoint', json);
        if (json?.statusCode == 200) {
          setData(json?.company);
        }
      })
  }

  useEffect(() => {
    if (user?.company)
      setEndpoint(user?.company?.endpoint)
  }, [props]);

  return (
    <React.Fragment>
      <Header history={props.history} backgroundColor={data?.theme} />
      <div className="page-content" style={{ backgroundImage: `url(${data?.cover})`, height: 961, backgroundRepeat: 'round' }}>
        {/* Render Breadcrumb */}
        <Breadcrumb title={Utils.projectName} breadcrumbItem={endpoint} />
        {props.error && props.error ? (
          <Alert color="danger">{props.error}</Alert>
        ) : null}
        {props.success && props.success ? (
          <Alert color="success">{props.success}</Alert>
        ) : null}
        <div className="d-flex" style={{ width: '100%' }}>
          <div style={{ width: '50%' }} className="account-pages my-5 pt-sm-5">
            <Card>
              <CardBody style={{ height: 500, margin: 'auto' }}>
                <div style={{ textAlign: 'center', marginTop: 30 }}>
                  <img src={data?.profile_picture} style={{ width: 100, height: 100 }} />
                </div>
                <div style={{ textAlign: 'center', marginTop: 30 }}>
                  <p><span style={{ fontWeight: 'bold' }}>{data?.name}<p>ID : <span style={{ fontWeight: 'bold' }}>{data?.compId}</span></p></span></p>
                  <span style={{width:'70%'}}>{data?.intro}</span>
                </div>
                <div className="d-flex" style={{ justifyContent: 'space-between', alignItems: 'self-end', marginTop: 40 }}>
                  <div style={{ marginRight: 30 }}>
                    <p>Email : <span style={{ fontWeight: 'bold' }}>{data?.email}</span></p>
                    <p>Website : <span style={{ fontWeight: 'bold' }}>{data?.website}</span></p>
                    <p>Address : <span style={{ fontWeight: 'bold' }}>{data?.address}</span></p>
                  </div>
                  <div style={{ marginLeft: 30, display: 'flex' }}>
                    <a style={{ margin: 10 }} href={data?.website}>
                      <img src="https://spng.pngfind.com/pngs/s/211-2116593_web-solution-png-icon-website-logo-clipart-png.png" style={{ width: 50, height: 50 }} />
                    </a>
                    {data?.facebook &&
                      <a style={{ margin: 10 }} href={data?.facebook}>
                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Facebook_f_logo_%282019%29.svg/2048px-Facebook_f_logo_%282019%29.svg.png" style={{ width: 50, height: 50 }} />
                      </a>
                    }
                    {data?.linkedin &&
                      <a style={{ margin: 10 }} href={data?.linkedin}>
                        <img src="https://cdn-icons-png.flaticon.com/512/174/174857.png" style={{ width: 50, height: 50 }} />
                      </a>
                    }
                    {data?.instagram &&
                      <a style={{ margin: 10 }} href={data?.instagram}>
                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Instagram_logo_2016.svg/2048px-Instagram_logo_2016.svg.png" style={{ width: 50, height: 50 }} />
                      </a>
                    }
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
          <div style={{ width: '50%' }}>
            <Login />
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

Company.propTypes = {
  getProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
  companyError: PropTypes.func,
  companySuccess: PropTypes.func,
  createCompany: PropTypes.func,
  updateCompany: PropTypes.func
}

const mapStatetoProps = state => {
  const { user } = state.Profile;
  const { error, success, company } = state.Company;
  return { error, success, user, company }
}

export default withRouter(
  connect(mapStatetoProps, { createCompany, companySuccess, companyError, getProfile, updateCompany })(Company)
)
